<script lang="ts">
	import { CircleAvatar } from '@Shelly/shelly-design-system';
	import { getDeviceIcon, getDeviceImage } from 'src/helpers/device_state_view_helpers';
	import type { Device } from 'src/types/Device';

	export let device: Device | undefined;
	export let size: 's' | 'm' | 'l' = 'm';

	$: image = device ? getDeviceImage(device) : 'images/device_images/S3EM-003CXCEU63.png';
	$: icon = device ? getDeviceIcon(device) : 'fak fa-solid-shelly';
</script>

<CircleAvatar {size} {image} {icon} backgroundColor={device?.backgroundColor} />
